import { useCallback, useEffect } from 'react';
import Box from '@material-ui/core/Box';
// import { Paper, Card, CardHeader, CardContent } from '@material-ui/core';
import { useSelector, useDispatch } from 'dva';
// import Divider from '@/assets/img/line.png';

export default () => {
  const dispatch = useDispatch();

  const stroeInfo = useSelector((state) => state.emp_search.stroeInfo);

  const fetchUserStore = useCallback(() => {
    dispatch({
      type: 'emp_search/getStoreInfo',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);

  useEffect(() => {
    fetchUserStore();
  }, [fetchUserStore]);

  return (
    <>
      <Box className="store-info-box">
        <Box mb={6} className="store-name">
          <span>{stroeInfo?.belongToStore}</span>
        </Box>
        {/* <CardHeader title="门店注册会员数"></CardHeader>
        <CardContent className="r1">
          <div className="r1_c1">
            <div>136</div>
            <div>昨天</div>
          </div>
          <img src={Divider} alt="" className={'divider'} />
          <div className="r1_c2">
            <div>68</div>
            <div>今天</div>
          </div>
          <img src={Divider} className={'divider'} alt="" />
          <div className="r1_c2">
            <div>1369</div>
            <div>上周</div>
          </div>
        </CardContent> */}
      </Box>
    </>
  );
};
